import { CCFormFields } from '@freelancer/billing';
import { LatinAmericaFormFields } from '../latin-america-form/latin-america-form.component';

export enum CCMethodForms {
  CC_FORM = 'CCForm',
  LATIN_AMERICA_FORM = 'LatinAmericaForm',
}

export interface IFrameFieldStatus {
  valid: boolean | undefined;
  touched: boolean;
  focus: boolean;
}

export const latinFormFieldsToCCFormFieldsMapping = new Map<
  LatinAmericaFormFields,
  CCFormFields
>([
  [LatinAmericaFormFields.ADDRESS, CCFormFields.ADDRESS],
  [LatinAmericaFormFields.COUNTRY_CODE, CCFormFields.COUNTRY_CODE],
  [LatinAmericaFormFields.CITY, CCFormFields.CITY],
  [LatinAmericaFormFields.BIRTH_DATE, CCFormFields.BIRTH_DATE],
  [LatinAmericaFormFields.EMAIL, CCFormFields.EMAIL],
  [LatinAmericaFormFields.PHONE, CCFormFields.PHONE],
  [LatinAmericaFormFields.STREET_NUMBER, CCFormFields.STREET_NUMBER],
  [LatinAmericaFormFields.STREET_COMPLEMENT, CCFormFields.STREET_COMPLEMENT],
  [LatinAmericaFormFields.ZIP, CCFormFields.ZIP],
  [LatinAmericaFormFields.STATE, CCFormFields.STATE],
  [LatinAmericaFormFields.CPF, CCFormFields.DOCUMENT],
  [LatinAmericaFormFields.RUT, CCFormFields.RUT],
]);
